module.exports = __webpack_public_path__ + "static/media/1.3 Barbara Gesicht.7204abb4.jpg";